'use es6';

import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { IS_MULTI_CONFIG_REPORT } from '../../problems';
import { isMultiConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const useCustomizeReportProblem = ({
  report
}) => {
  if (isMultiConfigReport(report)) {
    return {
      problem: IS_MULTI_CONFIG_REPORT,
      disabledMessage: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-action-components.actions.editReport.button.tooltip.isMultiConfigReport"
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useCustomizeReportProblem;